import React, { useCallback, useState } from "react";
import styles from "./styles.module.css";
import TabButton from "./TabButton";
import TabContent from "./TabContent";
const Tabs = ({
  defaultActive,
  items,
  onChange,
  containerStyles,
  buttonsStyles,
  buttonStyle,
  activeButtonStyle,
  contentStyles,
  isScroll,
}) => {
  const [activeKey, setActiveKey] = useState(defaultActive || items[0]?.key);

  const handleTabChange = useCallback(
    (key) => {
      setActiveKey(key);
      if (onChange) {
        onChange(key);
      }
    },
    [onChange]
  );
  return (
    <div className={`${styles["tabs-container"]} ${containerStyles}`}>
      <div
        className={isScroll ? `${styles["tabs-buttons-container-active"]}` : ""}
      >
        <div
          className={`${styles["tabs-buttons"]} ${
            buttonsStyles ? buttonsStyles : styles["tabs-buttons-default"]
          } `}
        >
          {items.map((item) => (
            <TabButton
              key={item.key}
              active={activeKey === item.key}
              onClick={() => handleTabChange(item.key)}
              label={item.label}
              buttonStyle={buttonStyle}
              activeButtonStyle={activeButtonStyle}
            />
          ))}
        </div>
      </div>
      <div
        className={`${styles["tabs-content"]} ${
          contentStyles ? contentStyles : styles["tabs-content-default"]
        }`}
      >
        {items.map((item) => (
          <TabContent
            key={item.key}
            isActive={activeKey === item.key}
            children={item.children}
          />
        ))}
      </div>
    </div>
  );
};

export default Tabs;
